import { useTranslation } from "react-i18next";
import { useInView } from "@/hooks/useInView";

export function FieldOpsIllustration() {
  const { t } = useTranslation();
  const { ref, inView } = useInView();

  const tasks = [
    { text: t("landing.illustrations.scoutBlockA3", "Scout Block A3"), done: true },
    { text: t("landing.illustrations.applyTreatmentB7", "Apply treatment B7"), done: true },
    { text: t("landing.illustrations.checkStickyTraps", "Check sticky traps"), done: true },
    { text: t("landing.illustrations.updateStockRecords", "Update stock records"), done: false },
  ];

  return (
    <div ref={ref} className="rounded-2xl border border-landing-border bg-white p-6 shadow-soft">
      {/* Progress header */}
      <div className="mb-4">
        <div className="mb-1.5 flex items-center justify-between text-xs text-muted-foreground">
          <span>{t("landing.illustrations.todaysTasks", "Today's tasks")}</span>
          <span className="font-medium text-foreground">
            {t("landing.illustrations.tasksDone34", "3/4 done")}
          </span>
        </div>
        <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
          <div
            className="h-full rounded-full bg-landing-accent transition-all duration-700"
            style={{ width: inView ? "75%" : "0%" }}
          />
        </div>
      </div>

      {/* Task list */}
      <div className="space-y-3">
        {tasks.map((task, i) => (
          <div
            key={i}
            className="flex items-center gap-3 transition-all duration-300"
            style={{
              opacity: inView ? 1 : 0,
              transform: inView ? "translateX(0)" : "translateX(10px)",
              transitionDelay: `${i * 0.12}s`,
            }}
          >
            <div
              className={`flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full text-[10px] font-bold ${
                task.done ? "bg-landing-accent text-white" : "border-2 border-muted-foreground/30"
              }`}
            >
              {task.done && "✓"}
            </div>
            <span className={`text-sm ${task.done ? "text-muted-foreground line-through" : "font-medium text-foreground"}`}>
              {task.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
